import React from 'react'
import 'react-datepicker/dist/react-datepicker.css'

const CardFilter = ({
  filterTransaction,
  onChangeFilterTransaction,
  onResetFilter,
}) => {
    return (
        <div className="card-toolbar my-1 d-flex align-items-center filter-container">

    {/* Phòng ban */}
    <div className="d-flex align-items-center filter-item me-5">
        <span style={{ fontSize: '12px', marginRight: 10 }}>
        Phòng ban:
        </span>
        <input
        type="text"
        className="form-control form-control-solid form-control-sm"
        placeholder="Phòng ban"
        value={filterTransaction.department}
        onChange={(event) =>
            onChangeFilterTransaction({ department: event.target.value })
        }
        style={{
            width: '180px',
        }}
        />
    </div>

    {/* Card ID Input */}
    <div className="d-flex align-items-center filter-item me-5">
        <span style={{ fontSize: '12px', marginRight: 10 }}>
        Card ID:
        </span>
        <input
        type="text"
        className="form-control form-control-solid form-control-sm"
        placeholder="Mã thẻ"
        value={filterTransaction.cardId}
        onChange={(event) =>
            onChangeFilterTransaction({ cardId: event.target.value })
        }
        style={{
            width: '180px',
        }}
        />
    </div>

    {/* User id */}
    <div className="d-flex align-items-center filter-item me-5">
        <span style={{ fontSize: '12px', marginRight: 10 }}>
            User ID:
        </span>
        <input
        type="text"
        className="form-control form-control-solid form-control-sm"
        placeholder="Mã nhân viên"
        value={filterTransaction.employerId}
        onChange={(event) =>
            onChangeFilterTransaction({ employerId: event.target.value })
        }
        style={{
            width: '180px',
        }}
        />
    </div>
    {/* Reset Filter Button */}
    <img
        onClick={onResetFilter}
        className="cursor-pointer filter-reset"
        src="/assets/images/reset.png"
        alt="reset-filter"
        width={30}
        style={{ marginLeft: '10px' }}
    />
    </div>
  )
}

export default CardFilter
